// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_count.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_count',
	field: function(rule) {
		return (rule && rule.setting && rule.setting.count === 'best') ? 'g.game_players_best' : 'g.game_players_recommended'
	},
	match: function(rule, config, filter, data, query) {
		var op = (rule.logic.operand === '=') ? 'contains' : 'not contains'
		query.where(this.field(rule), op, Rule.value(rule))
	},
	min: function(rule, config, filter, data, query) {
		var from = Rule.value(rule)
		if (rule.logic.operand === '>') from += 1
		var index = []
		for (var i = from; i <= 100; i++) index.push(i)
		query.where(this.field(rule), 'contains one', index)
	},
	max: function(rule, config, filter, data, query) {
		var to = Rule.value(rule)
		if (rule.logic.operand === '<') to -= 1
		var index = []
		for (var i = 1; i <= to; i++) index.push(i)
		query.where(this.field(rule), 'contains one', index)
	},
	range: function(rule, config, filter, data, query) {
		var from = Rule.value(rule)
		var to = Rule.value(rule, 'to')
		var index = []
		for (var i = from; i <= to; i++) index.push(i)
		query.where(this.field(rule), 'contains one', index)
	},
	tolerance: function(rule, config, filter, data, query) {
		var from = Rule.value(rule) - Rule.value(rule, 'tolerance')
		var to = Rule.value(rule) + Rule.value(rule, 'tolerance')
		var index = []
		for (var i = from; i <= to; i++) index.push(i)
		query.where(this.field(rule), 'contains one', index)
	}
})
